export default __webpack_public_path__ + "static/media/bitcoin-logo.e531cc7c.webp";